import React, { useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  SafeAreaView,
  Image,
  TextInput,
  TouchableOpacity,
  ScrollView,
  Platform,
} from "react-native";
import { useNavigate } from "react-router-dom";

import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
// import { useTranslation } from "react-i18next";
import Appstyles from "../../Constants/AppStyles";
import AppColors from "../../Constants/AppColors";
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;
const Login = ({ navigation }) => {
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [emailOrPhoneErrorMessage, setEmailOrPhoneErrorMessage] = useState("");
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [buttonColor, setButtonColor] = useState("#8F430080");
  const navigate = useNavigate();

  // const { t } = useTranslation(["common"]);

  const validateForm = () => {
    if (!emailRegex.test(emailOrPhone) && !phoneRegex.test(emailOrPhone)) {
      setEmailOrPhoneErrorMessage("Invalid email address or phone number.");
      setButtonColor("#8F430080");
    } else {
      setEmailOrPhoneErrorMessage("");
    }

    if (password.length < 6) {
      setPasswordErrorMessage("Password must be at least 6 characters long.");
      setButtonColor("#8F430080");
    } else {
      setPasswordErrorMessage("");
    }

    if (
      (emailRegex.test(emailOrPhone) || phoneRegex.test(emailOrPhone)) &&
      password.length >= 6
    ) {
      setButtonColor("#9C4900");
    }
  };

  return (
    <ScrollView
      contentContainerStyle={{ flexGrow: 1 }}
      keyboardShouldPersistTaps="handled"
      showsVerticalScrollIndicator={false}
    >
      <SafeAreaView
      // style={Appstyles.LoginContainer}
      >
        {/* Login Image Section */}
        <View>
          <Image
            source={AppImages.VehicleLogin}
            style={Appstyles.VehicleLoginImage}
          />
          {/* <Image source={AppImages.LoginLogo} style={Appstyles.VehicleLogo} /> */}

          {/* Email / Mobile */}
          <View style={{ marginTop: 40 }}>
            <Text style={[Appstyles.EmailidTxt, { marginLeft: 20 }]}>
              {/* {t("common:translation.Email ID / Mobile Number")} */}
              Email ID / Mobile Number
            </Text>

            <TextInput
              // placeholder={t(
              //   "common:translation.Enter you Email ID / Mobile Number"
              // )}
              placeholder="Enter your Email ID / Mobile Number"
              // style={[Appstyles.EmailTextinput, { borderColor: "#ACACAC" }]}
              style={{
                borderColor: "#ACACAC",
                borderWidth: 1,
                padding: 10,
                margin: 20,
                borderRadius: 5,
              }}
              autoFocus={Platform.OS !== "web"} // prevents web warning
              value={emailOrPhone}
              placeholderTextColor={AppColors.dualbrown}
              onChangeText={(text) => {
                setEmailOrPhone(text);
                if (!emailRegex.test(text) && !phoneRegex.test(text)) {
                  setEmailOrPhoneErrorMessage(
                    "Invalid email address or phone number."
                  );
                  setButtonColor("#8F430080");
                } else {
                  setEmailOrPhoneErrorMessage("");
                  if (text.length >= 6 && password.length >= 6) {
                    setButtonColor("#9C4900");
                  } else {
                    setButtonColor("#8F430080");
                  }
                }
              }}
            />
          </View>

          {emailOrPhoneErrorMessage ? (
            <Text style={styles.errorText}>{emailOrPhoneErrorMessage}</Text>
          ) : null}

          {/* Password */}
          <View>
            <Text
              // style={[Appstyles.EmailidTxt, { marginTop: 0, marginLeft: 20 }]}
              style={{ marginLeft: 20, marginTop: 10 }}
            >
              {/* {t("common:translation.Password")} */}
              Password
            </Text>

            <TextInput
              placeholder="Password"
              secureTextEntry
              // style={[Appstyles.EmailTextinput, { borderColor: "#ACACAC" }]}
              style={{
                borderColor: "#ACACAC",
                borderWidth: 1,
                padding: 10,
                margin: 20,
                borderRadius: 5,
              }}
              placeholderTextColor={AppColors.dualbrown}
              value={password}
              onChangeText={(text) => {
                setPassword(text);
                if (text.length < 6) {
                  setPasswordErrorMessage(
                    "Password must be at least 6 characters long."
                  );
                  setButtonColor("#8F430080");
                } else {
                  setPasswordErrorMessage("");
                  if (
                    text.length >= 6 &&
                    (emailRegex.test(emailOrPhone) ||
                      phoneRegex.test(emailOrPhone))
                  ) {
                    setButtonColor("#9C4900");
                  } else {
                    setButtonColor("#8F430080");
                  }
                }
              }}
            />

            <View style={styles.passwordRow}>
              <Text style={styles.errorText}>{passwordErrorMessage}</Text>
              <TouchableOpacity
                onPress={() =>
                  navigate("/LoginApp/LoginApp/ForgetPasswordScreen/Access")
                }
              >
                <Text style={Appstyles.ForgotPassTxt}>
                  {/* {t("common:translation.Forgot Password?")} */}
                  Forgot Password?
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>

        {/* Login Button */}
        <TouchableOpacity
          onPress={() =>
            buttonColor !== "#8F430080" &&
            navigate("/Dashboard/DashboardMap/DashboardDetails/View")
          }
          // style={[Appstyles.LoginButton, { backgroundColor: buttonColor }]}
          style={[
            {
              backgroundColor: buttonColor,
              padding: 15,
              margin: 20,
              borderRadius: 5,
              alignItems: "center",
            },
          ]}
          disabled={buttonColor === "#8F430080"}
        >
          <Text style={Appstyles.LoginTxt}>
            {/* {t("common:translation.Log In")} */}
            Log In
          </Text>
        </TouchableOpacity>

        {/* Try for free */}
        <TouchableOpacity
          onPress={() => navigate("/DemoAccount")}
          style={styles.tryFreeBtn}
        >
          <Text
          // style={Appstyles.RegisterTxt}
          >
            {/* {t("common:translation.Try it for free")} */}
            Try it for free
          </Text>
        </TouchableOpacity>

        {/* OTP / Register */}
        <View style={styles.bottomRow}>
          <TouchableOpacity
            onPress={() => navigation.navigate("LoginContinue")}
            // style={[Appstyles.LoginWithOtpVw, { marginRight: 20 }]}
          >
            <Text style={Appstyles.RegisterTxt}>
              {/* {t("common:translation.Log In with OTP")} */}
              Log In with OTP
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() =>
              navigate("/LoginApp/LoginApp/SaveAndProceedAllDetails/Save")
            }
          >
            <Text style={Appstyles.RegisterTxt}>Register As Customer</Text>
          </TouchableOpacity>
        </View>
      </SafeAreaView>
    </ScrollView>
  );
};

export default Login;

const styles = StyleSheet.create({
  errorText: {
    color: "red",
    fontSize: 13,
    fontFamily: AppFonts.OverpassMedium,
    marginLeft: 20,
    marginTop: 5,
  },
  passwordRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginHorizontal: 20,
  },
  tryFreeBtn: {
    marginHorizontal: 20,
    marginBottom: 20,
    borderColor: AppColors.brown1,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    paddingVertical: 10,
  },
  bottomRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
  },
});
